import AppLayout from "../components/layout/AppLayout";
import DocumentSingleComponent from "../components/document/DocumentSingleComponent";

export default function DocumentSingle() {
  return (
    <AppLayout>
      <DocumentSingleComponent />
    </AppLayout>
  );
}
